import CanadaAddress from "../../../Widgets/AddressComplete/CanadaAddress";
import DateOfBirthInput from "../../../Widgets/ContactDetails/DateOfBirthInput";
import PhoneMobile from "../../../Widgets/ContactDetails/PhoneMobile";
import FirstNationStatusDetail from '../../../Widgets/FNIM/FirstNationStatusDetail';
import FamilyMembers from '../../../Widgets/FamilyMembers/FamilyMembers';
import MapLocation from '../../../Widgets/MapViewer/MapLocation';
import MapViewer from '../../../Widgets/MapViewer/MapViewer';
import BankDetails from '../../../Widgets/BankDetails/BankDetails';

export const DynamicDateOfBirthInput = ({ field, form, getResourceValue, getRefData, context, setFormData }) => {
    return (
        <DateOfBirthInput {...field.properties} form={form} getResourceValue={getResourceValue } getRefData={getRefData} context={context} setFormData={setFormData} />
    );
};

export const DynamicPhoneMobile = ({ field, form, getResourceValue, context, setFormData }) => {
    return (
        <PhoneMobile {...field.properties} form={form} getResourceValue={getResourceValue } context={context} setFormData={setFormData} />
    );
};

export const DynamicCanadaAddress = ({ field, form, getResourceValue, context, setFormData }) => {
    return (
        <CanadaAddress {...field.properties} form={form} getResourceValue={getResourceValue } context={context} setFormData={setFormData} />
    );
};

export const DynamicFirstNationStatusDetails = ({ field, form, getResourceValue, setFormData }) => {
    return (
        <FirstNationStatusDetail {...field.properties} form={form} getResourceValue={getResourceValue } setFormData={setFormData} />
    );
};

export const DynamicFamilyMembers = ({ field, form, getResourceValue, getRefData, setShowStepActionButtons, setFormData, context }) => {
    return (
        <FamilyMembers {...field.properties} form={form} getResourceValue={getResourceValue } getRefData={getRefData} setShowStepActionButtons={setShowStepActionButtons} setFormData={setFormData} context={context} gaTracking={field.gaTracking} />
    );
};

export const DynamicMapLocation = ({ field, form, getResourceValue, setFormData }) => {
    return (
        <MapLocation {...field.properties} form={form} getResourceValue={getResourceValue } setFormData={setFormData} gaTracking={field.gaTracking} />
    );
};

export const DynamicMapViewer = ({ field, form, context }) => {
    return (
        <MapViewer {...field.properties} form={form} context={context} />
    );
};


export const DynamicBankDetails = ({ field, form, context, getResourceValue, setFormData }) => {
    return (
        <BankDetails {...field.properties} form={form} context={context} getResourceValue={getResourceValue} setFormData={setFormData} />
    );
};